import ReactGA from 'react-ga4';

let isInitialized = false;

/**
 * Initialize Google Analytics
 */
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  if (!measurementId) {
    console.warn('Google Analytics Measurement ID not found');
    return;
  }

  if (!isInitialized) {
    ReactGA.initialize(measurementId, {
      gaOptions: {
        siteSpeedSampleRate: 100
      }
    });
    isInitialized = true;
    console.log('Google Analytics initialized');
  }
};

/**
 * Track page views
 */
export const trackPageView = (path) => {
  if (isInitialized) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

/**
 * Track custom events
 */
export const trackEvent = (category, action, label = '', value = 0) => {
  if (isInitialized) {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
  }
};

/**
 * Track user login
 */
export const trackLogin = (userRole) => {
  trackEvent('User', 'Login', userRole);
};

/**
 * Track user logout
 */
export const trackLogout = () => {
  trackEvent('User', 'Logout');
};

/**
 * Track document generation
 */
export const trackDocumentGeneration = (documentType) => {
  trackEvent('Document', 'Generate', documentType);
};

/**
 * Track patient creation
 */
export const trackPatientCreated = () => {
  trackEvent('Patient', 'Create');
};

/**
 * Track doctor creation
 */
export const trackDoctorCreated = () => {
  trackEvent('Doctor', 'Create');
};

/**
 * Track medical history creation
 */
export const trackMedicalHistoryCreated = () => {
  trackEvent('Medical History', 'Create');
};

/**
 * Track errors
 */
export const trackError = (errorMessage) => {
  trackEvent('Error', 'Exception', errorMessage);
};
